export default __webpack_public_path__ + "static/media/arrowleft.91020f9f.png";